/**
 * Threeds Resource Client
 * Axios-based API client for 3DS endpoints
 */

import { ApiClient } from './apiClient';

export interface ThreedsSession {
    id: string;
    sessionId: string;
    provider: string;
}

export interface CreateSessionRequest {
    provider: string;
    sessionData: any;
    paymentInstrumentId: string;
}

export class ThreedsResource {
    constructor(private apiClient: ApiClient) { }

    /**
     * Create a 3DS session
     */
    async createSession(request: CreateSessionRequest): Promise<ThreedsSession> {
        return this.apiClient.post('/api/v1/threeds/create-session', request);
    }
}
